import { useTranslations } from 'next-intl';
import { useProduct } from '../ProductCard';
import { format } from '@monofront/business/utils';
interface IProductTotalPrice {
  totalPrice: string;
}

export const ProductTotalPrice = ({ totalPrice }: IProductTotalPrice) => {
  const product = useProduct();

  if (!product) {
    return (
      <div
        data-testid="product-price"
        className="bg-black-200 h-4 animate-pulse tw-w-1/2 tw-grid-area-[price]"
      ></div>
    );
  }

  return (
    <p className="totalPrice tw-lf-title-sm tw-text-end tw-grid-area-[totalPrice]">
      {totalPrice}
    </p>
  );
};

export const ProductTotalPriceWithPfand = ({
  totalPrice,
}: IProductTotalPrice) => {
  const product = useProduct();
  const tCart = useTranslations('Cart');

  if (!product) {
    return (
      <div
        data-testid="product-price"
        className="bg-black-200 h-4 animate-pulse tw-w-1/2 tw-grid-area-[price]"
      ></div>
    );
  }

  return (
    <div className="!tw-ml-0 tw-flex tw-w-[92px] tw-flex-col tw-justify-center tw-text-end tw-grid-area-[totalPrice]">
      <p className="totalPrice tw-lf-title-sm">{totalPrice}</p>
      {product.meta.finance?.pfand && (
        <p className="tw-text-sm tw-text-black-700">
          {tCart('pfandPrice', {
            price: format(product.meta.finance?.pfand ?? 0),
          })}
        </p>
      )}
    </div>
  );
};
